import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingTop: 74,
    paddingBottom: 74,
  },
  avatar: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
  qrImageRoot: {
    position: "relative",
    height: "100%",
  },
  qrImageCover: {
    zIndex: 1,
    height: "inherit",
  },
  MuiCardActionArea: {
    height: "inherit",
    zIndex: 1,
  },
}));

const CityViews = ({ className, ...rest }) => {
  const classes = useStyles();

  useEffect(() => {}, []);

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <div id="api-catalogue">
        <Container maxWidth="lg">
          <Typography variant="h2" align="center" style={{ color: "#5850EC" }}>
            Transform Your Brand with Artistic QR Codes!!
          </Typography>

          <Box mt={8}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
              <Card className={classes.qrImageRoot}>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "https://ai.qrcodes.apitier.com/login" }}
                    target="_blank"
                  >
                    <CardContent>
                      <Box
                        display="flex"
                        textAlign="center"
                        alignItems="center"
                        flexDirection="column"
                      >
                        <CardMedia
                          component="img"
                          classes={{ root: classes.qrImageCover }}
                          image={"/static/qrcodes/Verona_Italy_city_view.png"}
                          title={"Verona Italy City view as QRCode"}
                        />

                        <Typography
                          variant="h5"
                          gutterBottom
                          color="textPrimary"
                        >
                          Verona Italy City view as QRCode
                        </Typography>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item xs={12} md={3}>
                <Card className={classes.qrImageRoot}>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "https://ai.qrcodes.apitier.com/login" }}
                    target="_blank"
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      flexDirection="column"
                      textAlign="center"
                      justifyContent="center"
                    >
                      <CardMedia
                        component="img"
                        classes={{ root: classes.qrImageCover }}
                        image={"/static/qrcodes/newyork_city_view.png"}
                        title={"NewYork City View as QR Code"}
                      />
                      <Typography variant="h5" gutterBottom color="textPrimary">
                        NewYork City View as QR Code
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item xs={12} md={3}>
              <Card className={classes.qrImageRoot}>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "https://ai.qrcodes.apitier.com/login" }}
                    target="_blank"
                  >
                    <CardContent>
                      <Box
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                        textAlign="center"
                        justifyContent="center"
                      >
                        <CardMedia
                          component="img"
                          classes={{ root: classes.qrImageCover }}
                          image={"/static/qrcodes/paris_city_view.png"}
                          title={"Paris City view as QRCode"}
                        />

                        <Typography
                          variant="h5"
                          gutterBottom
                          color="textPrimary"
                        >
                          Paris City View as QR Code
                        </Typography>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid item xs={12} md={3}>
              <Card className={classes.qrImageRoot}>

                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "https://ai.qrcodes.apitier.com/login" }}
                    target="_blank"
                  >
                    <CardContent>
                      <Box
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                        textAlign="center"
                        justifyContent="center"
                      >
                        <CardMedia
                          component="img"
                          classes={{ root: classes.qrImageCover }}
                          image={
                            "/static/qrcodes/coca_cola_christmas_advertisment.png"
                          }
                          title={"Coca Cola Christmas Advertisment"}
                        />

                        <Typography
                          variant="h5"
                          gutterBottom
                          color="textPrimary"
                        >
                          Coca Cola Christmas Advertisment
                        </Typography>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </div>
    </div>
  );
};

CityViews.propTypes = {
  className: PropTypes.string,
};

export default CityViews;
